import React from 'react';
import Container from './styled';

interface LegendDescriptionProps {
  descriptions: string[];
}

const LegendDescription = ({ descriptions }: LegendDescriptionProps) => (
  <Container>
    {descriptions.map((description) => (
      <li key={description.length}>{description}</li>
    ))}
  </Container>
);

export default LegendDescription;
